import { useParams, Navigate } from 'react-router-dom';
import RoadNewApplication from 'src/pages/Permits/RoadPermit/NewApplication1';
import PlanningAndZoningNewApplication from 'src/pages/Permits/PlanningAndZoningPermit/NewApplication';
import TreePermitApplication from 'src/pages/Permits/TreePermit/TreePermitApplication';
import SolicitorNewApplication from 'src/pages/Permits/Solicitor/NewApplication';
import ConstructionPermitNewApplication from 'src/pages/Permits/Construction/NewApplication';
import CharitableSolicitationsNewApplication from 'src/pages/Permits/CharitableSolicitationsPermit/NewApplication';
import UsedCarDealerNewApplication from 'src/pages/Permits/UsedCarDealer/NewApplication';
import VendingNewApplication from 'src/pages/Permits/ClerkVending/VendingNewApplication';
import PetNewApplication from 'src/pages/Permits/PetPermit/NewApplication';
import FoodNewApplication from 'src/pages/Permits/Food&BeverageLicenseManagment/NewApplicationForm/NewApplication';

const NewApplicationRedirectHandler = () => {
  const { department, permit } = useParams();
  if (department === 'Engineering Department' && permit === '2') {
    return <RoadNewApplication />;
  } else if (department === 'Engineering Department' && permit === '4') {
    return <TreePermitApplication />;
  } else if (department === 'Planning Department' && permit === '1') {
    return <PlanningAndZoningNewApplication />;
  } else if (department === 'Clerk Department' && permit === '6') {
    return <SolicitorNewApplication />;
  } else if (department === 'Clerk Department' && permit === '5') {
    return <CharitableSolicitationsNewApplication />;
  } else if (department === 'Clerk Department' && permit === '7') {
    return <UsedCarDealerNewApplication />;
  } else if (department === 'Clerk Department' && permit === '8') {
    return <VendingNewApplication />;
  } else if (department === 'Building or Construction Department' && permit === '9') {
    return <ConstructionPermitNewApplication />;
  } else if (department === 'Department of Health or Animal Control' && permit === '10') {
    return <PetNewApplication />;
  }
  else if (department === 'Department of Health and Mental Hygiene' && permit === '12') {
    return <FoodNewApplication />;
  }

  return <Navigate to="/unauthorized" />;
};

export default NewApplicationRedirectHandler;
